var escape = require("../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".feedback-wrapper {\n  position: fixed;\n  bottom: 100px;\n  right: 0;\n  background: #1890ff;\n  height: 40px;\n  width: 40px;\n  cursor: pointer;\n}\n.feedback-wrapper .icon {\n  background: url(" + escape(require("../../img/feedback.png")) + ") no-repeat;\n  width: 25px;\n  height: 25px;\n  background-size: cover;\n  margin: 7px 0 0 8px;\n}\n.feedback-wrapper .icon-cover {\n  position: absolute;\n  z-index: 20;\n  top: 3px;\n  color: #fff;\n  width: 30px;\n  left: 5px;\n  font-size: 12px;\n}\n", ""]);

// exports
